import React from 'react';
import classNames from 'classnames';
// import { Panel } from 'react-bootstrap';

import LoadingSpinner from '../../shared/LoadingSpinner';
import Employee from './Employee';
import StandardCrew from './StandardCrew';
import styles from './AvailableEmployees.css';
import moment from 'moment';

const Results = ({ employees, loading, events, standardcrews, date, updateSelectedEmployeeList, entity, ...props }) => 
{

let selectedDayEmployees = [];
let sortedDayEmployees = [];
let seleccolor = '#304e1e'      
  employees.map(emp => {      
     events.map( evt =>{
      
         evt.crew? evt.crew.resources.forEach(res => {
          //if(res.resource.id === emp.id && moment(evt.endDate).isSame(date,'day') )
          if(res.resource && res.resource.id === emp.id && entity === evt.evttype )
          {               
            selectedDayEmployees.push(parseInt(emp.id));                                                
          } 
         }):'';             
     })
  })
 
  employees.map(emp => {        
    if(selectedDayEmployees.indexOf(emp.id) >= 0)
    {
      sortedDayEmployees.push({id:emp.id,firstName:emp.firstName,lastName:emp.lastName,color:seleccolor});
    }
    else
    {
      sortedDayEmployees.push({id:emp.id,firstName:emp.firstName,lastName:emp.lastName,color:''});
    }
  })
  sortedDayEmployees = sortedDayEmployees.sort((a,b)=>{return a.color.localeCompare(b.color)})
  
return (    
  <div className={classNames('panel panel-default', styles.results)} {...props}>    
    <div className={classNames('panel-body', styles.searchResultsContainer)}>
    {loading && <LoadingSpinner />}
    <div><p style={{fontSize:'16px'}}>Standard Crew</p></div>;
    {standardcrews.map((sc)=>{      
      if(standardcrews.length > 0)
      {
        
     return(
     <StandardCrew
     standardcrew={sc}
          key={sc.id}             
     />
     )
      }
     else
     return ('');
    }) }

    
    <div><p style={{fontSize:'16px'}}>Employees</p></div>
   
      {         
      
    sortedDayEmployees.map((e) =>       
     {
      return (                          
        <Employee             
          employee={e}
          key={e.id}   
          color={e.color}  
          updateSelectedEmployeeList = {updateSelectedEmployeeList}              
        />
      ) }

      
      )}
    </div>
  </div>
)
      
      
};



export default Results;

